$(() => {
    const inputs = $('.contact').find('input:not([type="checkbox"]):not([type="radio"])');
    const textareas = $('.contact').find('textarea');
    inputs.on('input', function() {
        if ($(this).val() === '') {
            $(this).removeClass('not-empty');
        } else {
            $(this).addClass('not-empty');
        }
    });

    textareas.on('input', function() {
        if ($(this).val() === '') {
            $(this).removeClass('not-empty');
        } else {
            $(this).addClass('not-empty');
        }
    });
});
